import React from 'react';
import PropTypes from 'prop-types';
import Uploader from 'Components/Files/GenericUploader/Uploader';
import { dispatchProfileImageChanged } from 'Hooks/useRefreshEvent';
import { UnderlineButton } from 'Components/ComponentLibrary/Atoms/UnderlineButton';


export const ProfileImageUploader = ({
  profileImageRelationship,
  onSuccess,
}) => {
  const [progress, setProgress] = React.useState(null);
  const isUploading = progress !== null;
  return (
    <Uploader
      accept={'image/x-png,image/png,image/jpeg'}
      url={profileImageRelationship.link('related').url()}
      setUploadProgress={(v) => {
        setProgress(v);
      }}
      onSuccess={() => {
        dispatchProfileImageChanged();
        onSuccess();
      }}
      onFinally={() => {
        setProgress(null);
      }}
      method="put"
      successToastMessage={'Profile image updated.'}
    >
      <UnderlineButton label={profileImageRelationship.meta('prompt')} disabled={isUploading} />
    </Uploader>
  );
};

ProfileImageUploader.defaultProps = {
  onSuccess: () => {},
};

ProfileImageUploader.propTypes = {
  profileImageRelationship: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
};
